const DEFAULT_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || "https://femtyz-admin.pixoatic.in/";

function getToken() {
  try {
    return localStorage.getItem("femtyz_token");
  } catch {
    return null;
  }
}

export async function apiRequest(path, { method = "GET", body, headers, token: tokenOverride } = {}) {
  const token = tokenOverride !== undefined ? tokenOverride : getToken();
  const res = await fetch(`${DEFAULT_BASE_URL}${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : null),
      ...(headers || null),
    },
    body: body ? JSON.stringify(body) : undefined,
  });

  const data = await res.json().catch(() => ({}));
  return { ok: res.ok, status: res.status, data };
}

export const API_BASE_URL = DEFAULT_BASE_URL;

export function getAuthHeader() {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
}

